import { getAhaBridge } from '@/app/bridge/ahaBridge';

const DEFAULT_DURATION_MS = 45000;
let appAuthLoadingUntil = 0;

const startNativeLoading = (
  title = 'Signing in...',
  maxVisibleMs = DEFAULT_DURATION_MS
) => {
  const request = getAhaBridge().loading.start({ title, maxVisibleMs });
  if (request?.catch) request.catch(() => {});
};

const endNativeLoading = () => {
  const request = getAhaBridge().loading.end();
  if (request?.catch) request.catch(() => {});
};

export const markAppAuthLoading = (
  durationMs = DEFAULT_DURATION_MS,
  options: { native?: boolean; title?: string } = {}
) => {
  if (typeof window === 'undefined') return;
  try {
    appAuthLoadingUntil = Date.now() + durationMs;
    if (options.native) {
      startNativeLoading(options.title, durationMs);
    }
  } catch {
    // ignore storage exceptions
  }
};

export const clearAppAuthLoading = () => {
  if (typeof window === 'undefined') return;
  try {
    appAuthLoadingUntil = 0;
    endNativeLoading();
  } catch {
    // ignore storage exceptions
  }
};

export const isAppAuthLoadingActive = () => {
  if (typeof window === 'undefined') return false;
  return Date.now() < appAuthLoadingUntil;
};
